import { Container } from '@material-ui/core'
import dynamic from 'next/dynamic'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { LazyComponent } from '../../components/lazyComponent/lazyComponent'
import { nonNull } from '../../utils/nonNull'
import { Banner, BannerCTA, CTALinksProvider } from './fragments'
import { HomepageQuery } from '@gql'

export type HomeProps = HomepageQuery & {
  //
}

const StyledHomeContainer = styled(Container)`
  padding: 0;
`

const BelowTheFold = dynamic(() => import('./fragments/belowTheFold').then(mod => mod.BelowTheFold))

export const Home: React.FC<PropsWithChildren<HomeProps>> = ({ entry, entries }) => {
  // We know this is always a homepage, but technically GraphQL says this could be any entry, so we must first check
  if (!entry || entry.__typename !== 'homePage_homePage_Entry') {
    return null
  }

  return (
    <StyledHomeContainer maxWidth={false}>
      {entry.bannerHome && (
        <Banner data={nonNull(entry.bannerHome)} />
      )}
      {entry.bannerCta && entry.bannerCtaTitle && (
        <CTALinksProvider>
          <BannerCTA title={entry.bannerCtaTitle} data={nonNull(entry.bannerCta)} />
        </CTALinksProvider>
      )}
      <LazyComponent>
        <BelowTheFold entry={entry} entries={entries} />
      </LazyComponent>
    </StyledHomeContainer>
  )
}

export { StyledHeading } from './styledHeading'
